import { fork, takeEvery, all } from 'redux-saga/effects';
import config from '../../../config/config';
import { WALLET_SETTLEMENT_LIST_REQUEST, SETTLEMENT_LIST_APPROVAL_REQUEST } from '../../constants/wallet/settlementConstants';
import {
  PerplayDailySettlementApi, SettlementControllerDtoDoSettlementRequest,
  SettlementControllerDtoListSettlementRequest
} from '../../models/src';
import { getErrorMessage } from '../../../utils/serverErrorCheck';
import SettlementControllerDtoListSettlementResponse
  from '../../models/src/model/SettlementControllerDtoListSettlementResponse';
import SettlementControllerDtoDoSettlementResponse
  from '../../models/src/model/SettlementControllerDtoDoSettlementResponse';

const api = new PerplayDailySettlementApi(config.API_CLIENT);

function* settlementListRequestSaga(payload) {
  console.assert(payload.callback, {
    message: 'callback이 설정되지 않았습니다.',
  });

  try {
    const requestData = new SettlementControllerDtoListSettlementRequest();
    requestData.transactionStatus = payload.transactionStatus;
    requestData.settlementType = payload.settlementType;
    requestData.from = payload.from;
    requestData.to = payload.to;
    requestData.settlementIds = payload.settlementIds;
    console.log('요청 데이터: ', requestData);

    const result = yield api.apiPerplayDailySettlementListSettlementPost({ settlementControllerDtoListSettlementRequest: requestData }, () => {});
    const data = api.apiClient.deserialize(result, SettlementControllerDtoListSettlementResponse);

    if (data.resultCode !== 200) {
      throw new Error(getErrorMessage(data));
    }

    payload.callback(data);
  } catch (e) {
    payload.error(e);
  }
}

function* settlementListApprovalRequestSaga(payload) {
  console.assert(payload.callback, {
    message: 'callback이 설정되지 않았습니다.',
  });

  try {
    const requestData = new SettlementControllerDtoDoSettlementRequest();
    requestData.issuer = payload.issuer;
    requestData.dryRun = payload.dryRun;
    requestData.settlementIds = payload.settlementIds;
    console.log('요청 데이터: ', requestData);

    const result = yield api.apiPerplayDailySettlementDoSettlementPost({ settlementControllerDtoDoSettlementRequest: requestData }, () => {});
    const data = api.apiClient.deserialize(result, SettlementControllerDtoDoSettlementResponse);

    if (data.resultCode !== 200) {
      throw new Error(getErrorMessage(data));
    }

    payload.callback(data);
  } catch (e) {
    payload.error(e);
  }
}

function* walletSettlementRootSaga() {
  yield all([
    takeEvery(WALLET_SETTLEMENT_LIST_REQUEST, settlementListRequestSaga),
    takeEvery(SETTLEMENT_LIST_APPROVAL_REQUEST, settlementListApprovalRequestSaga),
  ]);
}

const walletSettlementSagas = [
  fork(walletSettlementRootSaga),
];

export default walletSettlementSagas;
